function ComingSoon() {
  return (
    <div className="flex items-center justify-center h-[70vh]">
      <div className="bg-white p-10 rounded-2xl shadow-lg text-center">

        <div className="text-6xl mb-4">
          🚧
        </div>

        <h1 className="text-3xl font-bold text-slate-800">
          Daily Saving Hub
        </h1>

        <p className="text-slate-500 mt-3">
          This module is currently under development.
        </p>

      </div>
    </div>
  );
}

export default ComingSoon;